import { ButtonLink } from '@app/components/base/ButtonLink';
import { Button } from '@mui/material';
import { ReactNode } from 'react';

type FragmentLoggerActionButtonProps = {
  /** Router target. Omitted when the button is disabled. */
  to?: string;
  startIcon: ReactNode;
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
};

/**
 * Shared outlined button for fragment → Logger navigation actions.
 * Matches page header secondary actions (e.g. Clonar): outlined, small, no uppercase.
 */
export function FragmentLoggerActionButton({
  to,
  startIcon,
  children,
  onClick,
  disabled = false,
}: FragmentLoggerActionButtonProps) {
  const sharedProps = {
    size: 'small' as const,
    variant: 'outlined' as const,
    color: 'secondary' as const,
    startIcon,
    onClick,
    sx: { textTransform: 'none' as const },
  };

  if (disabled || !to) {
    return (
      <Button {...sharedProps} disabled={disabled}>
        {children}
      </Button>
    );
  }

  return (
    <ButtonLink {...sharedProps} to={to}>
      {children}
    </ButtonLink>
  );
}
